import type { Pead } from "epsm-api-types/models";
import type { PeadFilterType } from "../../../types";

export function filterDriftsDependingOnQtr(
	data: Pead[],
	last20quarters: boolean,
	peadFilter: PeadFilterType,
) {
	const filteredData = data?.filter((d) => {
		if (peadFilter === "PEAD") {
			return d.drift_unit.name === "type_based";
		}

		return d.drift_unit.name === "seasonal";
	});

	if (last20quarters) {
		return filteredData
			.filter((d: Pead) => {
				return d.overall_count <= 20;
			})
			.slice(0, 20);
	}

	const drifts40qrt = filteredData.filter((d: Pead) => d.overall_count > 20);

	const firstDriftWith20QtrIndex = filteredData.findLastIndex(
		(d: Pead) => d.overall_count === 20,
	);

	if (firstDriftWith20QtrIndex === -1) {
		return filteredData;
	}

	const drifts20Qtr = filteredData.slice(firstDriftWith20QtrIndex);

	return [...drifts40qrt, ...drifts20Qtr].slice(0, 40);
}
